import { z } from 'zod'

// ─── Mail-ingest quarantaine (fase F, spec 44) ───────────────────────────────
// Bestanden die door de Defender-malware-scan geblokkeerd zijn, over de
// mail-ingest-pijplijnen heen. Alleen ADMINs zien/vrijgeven ze.

/** De mail-ingest-bronnen (matcht de tabel-routering in de API). */
export const MAIL_QUARANTAINE_BRONNEN = [
  'inkoop',
  'verloning',
  'recruitment',
  'brandstof',
  'onderhoudsrapport',
  // batch-54 klant-akkoord-mail (FO-412) — de zesde ingest. Zonder deze bron
  // zou een geblokkeerde klant-reactie onbereikbaar blijven: wel een
  // ADMIN-alarm, geen vrijgave-pad.
  'klant-akkoord-mail',
  // batch-63 cursusplanning (FO-468) — antwoorden van opleiders op een
  // cursusaanvraag (zelfde vrijgave-pad).
  'cursusaanvraag-mail',
  // Verkoopfacturen-mailbox — de zevende ingest (zelfde vrijgave-pad).
  'verkoop',
  // batch-63 certificaat-mailbox (FO-469) — de achtste ingest.
  'certificaat',
] as const
export type MailQuarantaineBron = (typeof MAIL_QUARANTAINE_BRONNEN)[number]

export const MAIL_QUARANTAINE_BRON_LABELS: Record<MailQuarantaineBron, string> = {
  inkoop: 'Inkoop',
  verloning: 'Verloning',
  recruitment: 'Recruitment',
  brandstof: 'Brandstof',
  onderhoudsrapport: 'Onderhoudsrapport',
  'klant-akkoord-mail': 'Klant-akkoord per mail',
  'cursusaanvraag-mail': 'Antwoord opleider (cursusaanvraag)',
  verkoop: 'Verkoopfacturen',
  certificaat: 'Certificaten',
}

/** Vrijgeven vereist een reden (audit); gedeeld schema voor form + API. */
export const vrijgeefQuarantaineSchema = z.object({
  reden: z.string().trim().min(5, 'Reden moet minimaal 5 tekens bevatten').max(1000),
})
export type VrijgeefQuarantaineInput = z.infer<typeof vrijgeefQuarantaineSchema>

/** Eén geblokkeerde ingest in de quarantaine-tab. */
export interface QuarantaineRow {
  id: string
  bron: MailQuarantaineBron
  afzender: string | null
  onderwerp: string | null
  ontvangenOp: string | null
  foutmelding: string | null
}
